/**
 * 活动报名表单设计器允许的组件分组（隐藏布局/高级组件）
 */
export const ACTIVITY_FORM_SCHEMA_GROUP = [
  {
    title: '基础组件',
    list: [
      'input',
      'textarea',
      'number',
      'select',
      'checkbox',
      'radio',
      'date',
      'time',
      'rate',
      'uploadFile',
      'uploadImg',
      'switch'
    ]
  }
]

/**
 * 从 k-form-design 模块导出中解析 nodeSchema。
 * UMD 入口下具名 import 常为 undefined，需兼容 default.nodeSchema。
 * @param {object|null|undefined} mod
 * @returns {object|null}
 */
export function resolveNodeSchema (mod) {
  if (!mod || typeof mod !== 'object') {
    return null
  }
  if (isUsableNodeSchema(mod.nodeSchema)) {
    return mod.nodeSchema
  }
  if (mod.default && isUsableNodeSchema(mod.default.nodeSchema)) {
    return mod.default.nodeSchema
  }
  return null
}

/**
 * 配置活动报名表单可用组件；无效时安全返回 false，避免页面白屏。
 * @param {object|null|undefined} nodeSchema
 * @returns {boolean}
 */
export function configureActivityFormSchema (nodeSchema) {
  if (!isUsableNodeSchema(nodeSchema)) {
    return false
  }
  nodeSchema.setSchemaGroup(ACTIVITY_FORM_SCHEMA_GROUP)
  return true
}

/**
 * @param {*} candidate
 * @returns {boolean}
 */
function isUsableNodeSchema (candidate) {
  return !!(candidate && typeof candidate.setSchemaGroup === 'function')
}
